import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'amber' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'amber',
  href = '#offer'
}: CTAButtonProps) {
  const colors = variant === 'amber' ? 'bg-brand-amber text-white hover:bg-[#cf620f] focus-visible:ring-brand-amber' : 'bg-white text-brand-deep hover:bg-brand-main focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-46" data-mp="2p11jpj8hm90k">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="3cnrk6g56tvj2" />
    </a>;
}